import * as React from 'react';
import { Form } from 'react-final-form';
import { Localizer } from 'services/Localizer';
import { FormValidationPromise } from 'shared/types';
import ShoppingListEditItemBody from './ShoppingListEditItemBody';
import { ShoppingListDto } from './types';

interface ShoppingListEditItemProps {
	shoppingListBeingEdited: ShoppingListDto;
	onSaveShoppingList: (formValues: ShoppingListDto, hasChanges: boolean) => FormValidationPromise<void>;
	onRemoveShoppingList?: (shoppingList: ShoppingListDto) => void;
	stopEditingShoppingList: () => void;
	isSaving: boolean;
	displayCancelButton: boolean;
	displaySaveButton: boolean;
	saveButtonText: string;
	dirtySaveButtonText: string;
	shoppingList?: ShoppingListDto[];
	isDeleting?: boolean;
}

export interface ShoppingListEditItemBodyProps {
	shoppingListBeingEdited: ShoppingListDto;
	stopEditingShoppingList: () => void;
	onRemoveShoppingList?: (shoppingList: ShoppingListDto) => void;
	isSaving: boolean;
	displayCancelButton: boolean;
	displaySaveButton: boolean;
	saveButtonText: string;
	dirtySaveButtonText: string;
	/** Whether to prevent the "Set as Default" checkbox from rendering */
	shoppingList?: ShoppingListDto[];
	dirty: boolean;
	isDeleting?: boolean;
}

/**
 * Handles loading the create/edit component.
 * Contains a form with the shopping list fields for add an shopping list.
 * Form validation, callbacks and data functions are handled in the containing component (ShoppingList).
 */
export default function ShoppingListEditItem(props: ShoppingListEditItemProps) {
	const { onSaveShoppingList, shoppingListBeingEdited } = props;

	return (
		<Form
			onSubmit={(values: ShoppingListDto, form) => {
				return onSaveShoppingList(values, form.getState().dirty);
			}}
			subscription={{ pristine: true, dirty: true, submitError: true }}
			initialValues={{
				...shoppingListBeingEdited,
			}}
			render={({ handleSubmit, dirty }) => {
				return (
					<form onSubmit={handleSubmit}>
						<ShoppingListEditItemBody {...props} dirty={dirty} />
					</form>
				);
			}}
		/>
	);
}

ShoppingListEditItem.defaultProps = {
	displayCancelButton: true,
	displaySaveButton: true,
	saveButtonText: Localizer('Save'),
	dirtySaveButtonText: Localizer('Save'),
};
